<div class="w-1/2">
  <app-feature-list-container>
    <h4>{{ '+SRC.DEVICE.VITOTROL_300E' | translate }}</h4>
    <vi-loader
      data-at-loader
      *ngIf="installationFeaturesStore.featuresLoading$ | async"
      [isLoading]="true"
      [message]="'+USER_REGISTRATION.USER_REGISTRATION.LOADING_MESSAGES.DATA' | translate"
    ></vi-loader>

    <!-- device name -->
    <ng-container *ngIf="deviceName$ | async | ready as deviceName">
      <app-feature-list-item
        data-at-device-name
        [label]="'+INSTALLATIONS.SRC.DEVICE.DESCRIPTION' | translate"
        [editable]="true"
        [value]="deviceName | value2: featurePropertyKey.name"
        (edit)="openEditDeviceNameDialog(deviceId)"
      >
      </app-feature-list-item>
    </ng-container>

    <!-- id -->
    <app-feature-list-item
      data-at-id
      [label]="'+INSTALLATIONS.SRC.DEVICE.ID' | translate"
      [value]="deviceId | idPrefixRemover | serialSpacing"
    >
    </app-feature-list-item>

    <!-- Device disconnected alert -->
    <ng-container *ngIf="status$ | async | ready as status">
      <ng-container
        *ngrxLet="installationService.isSrcDeviceNotConnected(status) as isNotConnected"
      >
        <!-- wifi lqi -->
        <app-feature-list-item
          data-at-air-quality-sensor-wifi-lqi
          *ngIf="wifiLqi$ | async | ready as feature"
          [error]="feature | error"
          [label]="'+INSTALLATIONS.SRC.ETRV.WIFI_LQI_STRENGTH.TITLE' | translate"
          [isNgContent]="true"
          timestamp="{{ feature?.timestamp | date: 'short' }}"
          [attr.data-feature]="feature.feature + '/strength'"
        >
          <ng-container
            *ngIf="
              feature.properties?.strength &&
                feature.properties?.strength?.value < lowLqiSignalThreshold;
              then lowSignal;
              else stableSignal
            "
          ></ng-container>

          <ng-template #lowSignal>
            <span class="warning-box">
              <mat-icon>error</mat-icon>
              {{
                isNotConnected
                  ? noValue
                  : (feature | value2: featurePropertyKey.strength) +
                    ' ' +
                    (feature | unit: 'strength')
              }}
            </span>
          </ng-template>

          <ng-template #stableSignal>
            {{
              isNotConnected
                ? noValue
                : (feature | value2: featurePropertyKey.strength) +
                  ' ' +
                  (feature | unit: 'strength')
            }}
          </ng-template>
        </app-feature-list-item>

        <!-- device.sensors.temperature -->
        <app-feature-list-item
          data-at-ventilation-device-sensor-temperature
          *ngIf="temperature$ | async | ready as feature"
          [error]="feature | error"
          [label]="'+INSTALLATIONS.SRC.ETRV.CURRENT_TEMPERATURE' | translate"
          value="{{
            isNotConnected
              ? noValue
              : (feature | value2: featurePropertyKey.value) + ' ' + (feature | unit: 'value')
          }}"
          [attr.data-feature]="feature.feature"
          timestamp="{{ feature.timestamp | date: 'short' }}"
        >
        </app-feature-list-item>

        <!-- device.sensors.humidity -->
        <app-feature-list-item
          data-at-humidity-remote
          *ngIf="humidity$ | async | ready as feature"
          [error]="feature | error"
          [label]="'+INSTALLATIONS.SRC.CS.HUMIDITY' | translate"
          value="{{
            isNotConnected
              ? noValue
              : (feature | value2: featurePropertyKey.value) + ' ' + (feature | unit: 'value')
          }}"
          [attr.data-feature]="feature.feature"
          timestamp="{{ feature.timestamp | date: 'short' }}"
        >
        </app-feature-list-item>

        <!-- device.sensors.firmware-->
        <app-feature-list-item
          data-at-cs-sensor-firmware
          *ngIf="firmware$ | async | ready as feature"
          [error]="feature | error"
          [label]="'+INSTALLATIONS.SRC.FIRMWARE' | translate"
          value="{{ feature | value2: featurePropertyKey.value }}"
          [attr.data-feature]="feature.feature"
          timestamp="{{ feature.timestamp | date: 'short' }}"
        >
        </app-feature-list-item>
      </ng-container>
    </ng-container>
  </app-feature-list-container>
</div>
